var booleanStatus = function (status) {
    return {
        status: status,
    };
};
/**
 * Datapoint configurations.
 */
export default {
    DeleteForwardedEventsNotificationOnOffStatus: {
        datapoint: {
            name: 'DeleteForwardedEventsNotificationOnOffStatus',
            customData: booleanStatus,
        },
    },
    DeleteUpdatedInvitationsOnOffStatus: {
        datapoint: {
            name: 'DeleteUpdatedInvitationsOnOffStatus',
            customData: booleanStatus,
        },
    },
};
//# sourceMappingURL=datapoints.js.map